import React, { useState, useContext, useEffect, useMemo } from 'react'
import UserContext from 'contexts/UserContext'
import { AddBeneficiary } from '../../helpers/api'
import { useFormik } from 'formik'
import * as yup from 'yup'
import drapeauTunisie from '../../assets/drapeauxCarres/drapeauTunisie.svg'
import iconSelectInput from '../../assets/iconSelectInput.svg'
import updateImage from '../../assets/updateImage.svg'
import CustomSelect from 'components/CustomSelect'
import ModalImageBeneficiary from './modalImageBeneficiary'
import imageDefault from '../../assets/imageDefault.jpeg'
import drapeauMaroc from '../../assets/drapeauxCarres/flagMaroc.svg'
import drapeauSenegal from '../../assets/drapeauxCarres/drapeauSenegal.svg'
import drapeauBangladesh from '../../assets/drapeauxCarres/FlagBangladesh.svg'
import drapeauTurkey from '../../assets/drapeauxCarres/FlagTurkey.svg'
import drapeauPakistan from '../../assets/drapeauxCarres/FlagPakistan.svg'
import drapeauNigeria from '../../assets/drapeauxCarres/nigeria.svg'
import drapeauKenya from '../../assets/drapeauxCarres/kenya.svg'

import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import Homme from '../../assets/logoHomme.svg'
import Femme from '../../assets/logoFemme.svg'
import { LISTBANCAIRE } from 'components/listCartebancairepays'
import { useLocation } from 'react-router-dom'
import InputSelectComponent from 'components/inputSelectComponent'
import { Philippines } from 'assets/drapeauxCarres'
type Table={
   icon: any;
    value: string,
     label:string, 
     lengthPhone: number, 
     code:string, 
     isWallet:boolean
}
interface Props {
  closeModal: () => void
  setIsAdded: any
  valuePays?: any
  code?: any
  isAddToContext?: boolean
  isOpenListPays?:boolean
}
type typeListebank = {
  index: number
  code: string
  name: string
  swift: string
}
type RibLength = number | {
  min: number
  max: number
}

const ModalAddBeneficiary: React.FC<Props> = ({
  closeModal,
  setIsAdded,
  valuePays,
  code,
  isAddToContext = true,
  isOpenListPays=true
}) => {
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)
  const [selectedImageId, setSelectedImageId] = useState<number | null>(25)
  const [newImage, setNewImage] = useState('')
  // const number = parseInt(code)
const location = useLocation()
  const currenPath = location.pathname  

  const [selectedOption, setSelectedOption] = useState('')
  const [selectedOptionGenre, setSelectedOptionGenre] = useState('')
  const [selectedOptionLien, setSelectedOptionLien] = useState('')
  const [isOpenGenre, setIsOpenGenre] = useState(false)
  const [isOpenLien, setIsOpenLien] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState<string>('')
  const [firstSubmit, setFirstSubmit] = useState(true)
  const [choisirImage, setChoisirImage] = useState(false)
  const [responseAddBeneficiary, setResponseAddBeneficiary] = useState(false)
  const [isDisabled, setIsDisabled] = useState<boolean>()
  const [OpenOptionnel, setOpenOptionnel] = useState(false)
  const [isConfirmIban, setIsConfirmIban] = useState<boolean>()
  const [isConfirmListBanc, setIsConfirmListBanc] = useState<boolean>()

  const [isObligatoire, setIsObligatoire] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [banqueName, setBanqueName] = useState('')
  const [lengthRIB, setLengthRIB] = useState<RibLength>()
  const [lengthCIN, setLengthCIN] = useState<number>()
    const [lengthNUM, setLenghtNUM]= useState(0)
    const[codeIso, setCodeIso]=useState('')
  
  const [lengthCodeIBAN, setLengthCodeIBAN]=useState<number>()
  const [bankcode, setBankcode] = useState('')
  const [swiftBic, setSwiftBic] = useState('')
  const [listCarteBancaire, setListCarteBancaire] = useState<typeListebank[]>()
  
  const [isBankListOpen, setIsBankListOpen] = useState(false)
  const [isSelectedBank, setIsSelectedBank] = useState(false)

  const  liste=selectedValue==='+90'? LISTBANCAIRE['TUR'].banks.map((item)=>({value:item.name, code:item.code, swift: item.swift })) 
  : selectedValue==='+63'? LISTBANCAIRE['PHL'].banks.map((item)=>({value:item.name, code:item.code, swift: item.swift }))
  : []
  

  const [codeIBAN, setCodeIBAN] = useState<string>('')
  const handleSelectedBank=(item:{value:string, code:string, swift: string })=>{
    setIsConfirmListBanc(true)
      setBankcode(item.code)
      setSwiftBic(item.swift)
      setBanqueName(item.value)
      
      setIsSelectedBank(true)
  
  setTransferData((prev:any) => ({
  ...prev, banqueName: item.value, bankcode:item.code, swiftBic:item.swift}))
  
}


  const closeModalImage = () => {
    setChoisirImage(false)
  }

  const handleImageClick = (index: number) => {
    setSelectedImageId(index)
  }

  const optionGenre = [
    { index: 26, code: 'female', name: 'Femme', image: Femme },
    { index: 25, code: 'male', name: 'Homme', image: Homme },
  ]

  const optionsLien = [
    { index: 0, code: 'FAMILY', name: 'Famille' },
    { index: 1, code: 'FRIEND', name: 'Amis' },
    { index: 2, code: 'SELF', name: 'Moi même' },
    { index: 3, code: 'OTHER', name: 'Autres' },
  ]

  const OPTIONS: Table[] = [
    { icon: drapeauTunisie, value: '+216',label:'+216', lengthPhone: 8, code: 'TUN', isWallet:false },
    { icon: drapeauMaroc, value: '+212', label:'+212' ,lengthPhone: 9, code: 'MAR' , isWallet:false},
    { icon: drapeauSenegal, value: '+221', label: '+221' ,lengthPhone: 9, code: 'SEN', isWallet:true },
    { icon: drapeauTurkey, value: '+90', label:'+90' ,lengthPhone: 10, code: 'TUR', isWallet:false },
    { icon: drapeauPakistan, value: '+92', label: '+92',lengthPhone: 10, code: 'PKR', isWallet:true },
    { icon: drapeauBangladesh, value: '+880', label: '+880',lengthPhone: 10, code: 'BGD', isWallet:false },
    { icon: drapeauKenya, value: '+254', label: '+254',lengthPhone: 9, code: 'KEN', isWallet:true },
    { icon: drapeauNigeria, value: '+234', label: '+234',lengthPhone: 10, code: 'NGA', isWallet:false },
    { icon: Philippines, value: '+63', label: '+63',lengthPhone: 10, code: 'PHL', isWallet:true },

  ]


// const options= code==='2' ? OPTIONS.filter((item)=>item.isWallet===true) : OPTIONS
const options = useMemo(
  () => code === '2' ? OPTIONS.filter((item) => item.isWallet) : OPTIONS,
  [code]
)


     useEffect(()=>{
      const destinationDefaultCountry= user?.user?.destinationDefaultCountry==='MAC' ? 'MAR' : user?.user?.destinationDefaultCountry
      const code = selectedValue ? options.find ((item)=>item.value===selectedValue)?.code
      : TransferData?.codeIso  ? TransferData.codeIso==='PAK' ? 'PKR':   TransferData.codeIso
      : destinationDefaultCountry

      
      const list=  options.find((item)=>item.code=== code)
     if(list)
                  {
                  setLenghtNUM(list.lengthPhone)

                    if(!selectedValue){setSelectedValue(list.value ||'')}
                   if(list.value==='+880') return      

                const data= LISTBANCAIRE[list.code]
                if (!data) {
                  console.error('Données bancaires introuvables pour', list.code)
                  return
                }
      

                   setListCarteBancaire(data.banks)
                   setLengthRIB(data.LengthRIB)
                   setLengthCIN(data.LengthCIN)
                  setLengthCodeIBAN(data.lengthCodeIBAN)
                   setCodeIBAN(data.CodeIBAN)
                  }
                 
              },[TransferData?.codeIso, selectedValue, user, selectedValue])

     


  const handleLienChange = (selectedOption: any) => {
    const userGender = user?.user?.personalInfo?.gender
    const genderOption = optionGenre.find((option) => option.code === userGender)?.code || ''

    if (selectedOption.name === 'Moi même') 

      {
      formik.setFieldValue('nom', user?.user?.personalInfo?.firstName)
      formik.setFieldValue('prenom', user?.user?.personalInfo?.lastName)
      setSelectedOptionGenre(genderOption)
      formik.setFieldValue('selectedOptionGenre', genderOption)
      formik.setFieldValue('selectedOptionLien', selectedOption.code)

        formik.setFieldTouched('nom', true)
        formik.setFieldTouched('prenom', true)
        formik.setFieldTouched('selectedOptionGenre', true)
        formik.setFieldTouched('selectedOptionLien', true)

      setIsDisabled(true)
    } 
    else {
      setIsDisabled(false)
    }
     setTimeout(() => {
    formik.validateForm()
  }, 0)
  }

  const handleSelect = (option: any) => {
    setSelectedOption(option.value)
     formik.setFieldValue('prefix', option.value)
    formik.setFieldValue('selectedOptionLien', option.code)
    handleLienChange(option)
  }

  const handleSelectGenre = (genre: any) => {
    setSelectedOptionGenre(genre)
    formik.setFieldValue('selectedOptionGenre', genre)
  }

  const handleSelectLien = (lien: any) => {
    setSelectedOptionLien(lien)
  }

  const initialFormData = {
    avatar: '',
    newImage: '',
    nom: '',
    prenom: '',
    telephone: '',
    prefix: selectedValue,
    selectedOptionLien: '',
    selectedOption: '',
    selectedOptionGenre: '',
    // cin:'',
    // iban:'',
    confirmerNumeroCompte: '',
    identifiantCardNumber: '',
    accountNumber: '',
    bankName: '',
    Iban: '',
    SWIFTBIC: '',
    bankCode: '',
  }

 
  const [formData, setFormData] = useState(initialFormData)

 

  const handleSubmit = async (values: typeof initialFormData) => {
    if (!user || !user.user || !user.token) {
      console.error('User information is missing.')
      return
    }
    const id = user.user._id
    const token = user?.token?.accessToken
    if (formik.isValid) {
      const newBeneficiary: any = {
        avatar: selectedImageId,
        firstName: values.prenom,
        lastName: values.nom,
        phonePrefix: selectedValue.slice(1),
        phoneNumber: values.telephone,
        relationship: values.selectedOptionLien,
        gender: values.selectedOptionGenre,
        beneficiaryIdentifiant: values.identifiantCardNumber,
        Iban: values.accountNumber,
        bankName: banqueName,

        SWIFTBIC: swiftBic,
        bankCode: bankcode,
        // cin: values.cin,
        // iban: values.iban,
        confirmerNumeroCompte: values.confirmerNumeroCompte,
      }

      // setDisabled(false)
      setFormData(initialFormData)
      setDisabled(true)
      setIsLoading(true)
      try {
        await AddBeneficiary(id, token, newBeneficiary)
          .then(async (response: any) => {
            if (response?.success) {
              if (isAddToContext) {
                setTransferData({
                  ...TransferData,
                  BeneficiaryName: `${response?.data?.personalInfo?.firstName} ${response?.data?.personalInfo?.lastName} `,
                  idBeneficiary: response?.data?._id,
                  cinBeneficiary: response?.data?.identifiantCardNumber,
                  numBankBeneficiary: response?.data?.accountNumber,
                  banqueName: response.data.bankName,
                  bankcode: response.data.bankCode,
                  swiftBic: response.data.SWIFTBIC,
                  phoneNumberBeneficiary: `${response?.data?.personalInfo.phone.prefix} ${response?.data?.personalInfo.phone.number} `,
                })
              }

              if (setIsAdded) {
                setIsAdded()
              }
              setFirstSubmit(false)
              setNewImage(newImage)
            } else if (!response?.success) {
              setResponseAddBeneficiary(true)
              closeModal()
            }
            closeModal()
          })
          .catch((error) => {
            console.log(error)
          })
      } catch (error) {
        console.error('Error adding beneficiary:', error)
      }
    } else {
      console.log('Le formulaire contient des erreurs')
    }
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
     e.preventDefault()
    const pastedText = e.clipboardData.getData('text')
    const cleaned = pastedText.replace(/\D/g, '') 
  formik.setFieldValue('telephone', cleaned)
    // if (!/^\d+$/.test(pastedText)) {
    //   e.preventDefault()
    // }
  }

   const validationSchema = useMemo(()=>  yup.object().shape({
    nom: yup
      .string()
      .matches(/^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/, 'Le nom doit contenir uniquement des lettres')
      .test('valid-spaces', 'Ce champ est requis', (value) => {
        if (!value) return false
        {
          return !/^\s| {2,}/.test(value)
        }
      })
      .required('Ce champ est requis'),
    prenom: yup
      .string()
      .matches(/^[a-zA-ZÀ-ÿ\u00C0-\u017F\s'’œŒæÆçÇ-]+$/, 'Prenom doit contenir uniquement des lettres')
      .test('valid-spaces', 'Ce champ est requis', (value) => {
        if (!value) return false
        {
          return !/^\s| {2,}/.test(value)
        }
      })
      .required('Ce champ est requis'),

    telephone: yup
      .string()
      .required('Ce champ est requis')
.matches(
      new RegExp(`^\\d{${lengthNUM}}$`),
      `Le numéro doit contenir ${lengthNUM} chiffres.`
    ),

      // .matches(new RegExp(`^\\d{${lengthNUM}}$`),`Le numéro doit contenir ${lengthNUM} chiffres.`),


      identifiantCardNumber: yup
  .string()
  .when('prefix', (prefix, schema) => {


    const currentPrefix =  Array.isArray(prefix)
    ? prefix[0]
    : prefix

    if (currentPrefix === '+212' || selectedValue==='+212') {
      return schema.matches(
        // /^[A-Z]{1,2}[0-9]{4,8}$/,
         /^[A-Z 0-9]{5,10}$/,
        'Format CIN Maroc invalide'
      )
    }

    return schema.matches(
      new RegExp(`^\\d{${lengthCIN}}$`),
      `Le numéro doit contenir exactement ${lengthCIN} chiffres`
    )
  }),

  //   identifiantCardNumber: yup
  // .string()
  // .when(['confirmerNumeroCompte'], ([confirmerNumeroCompte], schema) => {
  //   const stringSchema = schema as yup.StringSchema
  //   if (confirmerNumeroCompte) {
  //     return stringSchema.required('')
  //   }
  //   return stringSchema
  // })
  // .when('prefix', ([prefix], schema) => {
  //   if (prefix === '+212'  || (!prefix  && selectedValue=== '+212')) {
  //     return schema.matches(
  //       /^[A-Z 0-9]{5,10}$/,
  //       'Format CIN Maroc invalide'
  //     )
  //   }

  //   return schema.matches(
  //     new RegExp(`^\\d{${lengthCIN}}$`),
  //     `Le numéro doit contenir exactement ${lengthCIN} chiffres`
  //   )
  // }),

  accountNumber: yup
  .string()
  .when(
    ['identifiantCardNumber'],
    ([identifiantCardNumber], schema) => {
      const stringSchema = schema as yup.StringSchema

      if (identifiantCardNumber) {
        return stringSchema.required('')
      }

      return stringSchema
    }
  )
  .test(
    'account-number-length',
    function (value) {
      if (!value) return true

      const { path, createError } = this

      // Philippines : entre 10 et 16 chiffres
      if (
        selectedValue === '+63' &&
        typeof lengthRIB === 'object'
      ) {
        const { min, max } = lengthRIB

        if (
          value.length < min ||
          value.length > max ||
          !/^\d+$/.test(value)
        ) {
          return createError({
            path,
            message: `L'IBAN doit contenir entre ${min} et ${max} chiffres.`,
          })
        }

        return true
      }

      // Turquie : longueur exacte
      if (
        selectedValue === '+90' &&
        typeof lengthRIB === 'number'
      ) {
        if (
          value.length !== lengthRIB ||
          !/^\d+$/.test(value)
        ) {
          return createError({
            path,
            message: `L'IBAN doit contenir exactement ${lengthRIB} chiffres.`,
          })
        }

        return true
      }

      // Autres pays : longueur exacte
      if (typeof lengthRIB === 'number') {
        if (
          value.length !== lengthRIB ||
          !/^\d+$/.test(value)
        ) {
          return createError({
            path,
            message: `Le numéro de compte bancaire doit contenir exactement ${lengthRIB} chiffres.`,
          })
        }
      }

      return true
    }
  )
  .test(
    'bank-code-check',
    "Le RIB n'est pas correct.",
    function (value) {
      // TUR et PHL n'ont pas besoin de vérifier
      // le code bancaire ici
      if (
        selectedValue === '+90' ||
        selectedValue === '+63'
      ) {
        return true
      }

      const { path, createError } = this

      if (!value) return true

      if (!lengthCodeIBAN) return true

      const bankCode = value.substring(0, lengthCodeIBAN)

      const isValidBank = listCarteBancaire?.some(
        (bank) => bank.code === bankCode
      )

      if (!isValidBank) {
        return createError({
          path,
          message: "Le RIB n'est pas correct.",
        })
      }

      return true
    }
  ),
    
    // accountNumber: yup
    //   .string()
    //   .when(['identifiantCardNumber'], ([identifiantCardNumber], schema) => {
    //     const stringSchema = schema as yup.StringSchema
    //     if (identifiantCardNumber) {
    //       return stringSchema.required('')
    //     }
    //     return stringSchema
    //   })
    //   .test(
    //   'bank-code-check',
    //   "Le RIB n'est pas correct.",
    //   function (value) {
    //     if(selectedValue==='+90' || selectedValue ==='+63') return true
    //     const { path, createError } = this

    //     if (!value) return true

    //     // const codeLength = selectedValue === '+216' ? 2 : 3
    //     const bankCode = value.substring(0, lengthCodeIBAN)
    //     const isValidBank = listCarteBancaire?.some(bank => bank.code === bankCode)

    //     if (!isValidBank) {
    //       return createError({ path, message: 
    //     `${(selectedValue ==='+90' || selectedValue ==='+63') 
    //       ? ` L'IBAN doit contenir exactement ${lengthRIB} chiffres.` 
    //       : ` Le numéro de compte bancaire doit contenir exactement ${lengthRIB} chiffres.`}`, })
    //     }

    //     return true
    //   }
    
    // )
    //   .matches(
    //     new RegExp(`^\\d{${lengthRIB}}$`),
    //     `${(selectedValue ==='+90' || selectedValue ==='+63')
    //       ? ` L'IBAN doit contenir exactement ${lengthRIB} chiffres.` 
    //       : ` Le numéro de compte bancaire doit contenir exactement ${lengthRIB} chiffres.`}`,
    //   )
      

    confirmerNumeroCompte: yup
      .string()
      .oneOf([yup.ref('accountNumber')], `Les numéros ${(selectedValue ==='+90' || selectedValue ==='+63')? 'IBAN' : 'RIB ' } doivent correspondre.`)

      .when('$isObligatoire', {
        is: true,
        then: (schema) => schema.required(''),
        otherwise: (schema) => schema.notRequired(),
      }),

    selectedOptionLien: yup.string().required('Ce champ est requis'),
    selectedOptionGenre: yup.string().required('Ce champ est requis'),
  }),[lengthNUM,
  selectedValue,
  lengthCIN,
  lengthRIB,
  lengthCodeIBAN,
  listCarteBancaire])
  useEffect(() => {
    if(selectedValue==='+90' || selectedValue ==='+63')
    {setBanqueName('')
    setBankcode('')
    setSwiftBic('')}
  formik.setFieldValue('prefix', selectedValue)
}, [selectedValue])

  useEffect(() => {
  
  if (formik.values) {
    formik.validateField('telephone')
    formik.validateField('identifiantCardNumber')
    formik.validateField('accountNumber')
    
  }
}, [lengthNUM])


  const formik = useFormik({
    initialValues: initialFormData,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  //   validateOnBlur: true, 
  // validateOnChange: true,     
  })

  const isMorocco =
  formik.values.prefix === '+212' || selectedValue === '+212'

  const handleKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (
    (e.ctrlKey || e.metaKey) &&
    ['v', 'c', 'a', 'x'].includes(e.key.toLowerCase())
  ) {
    return
  }

  if (
    ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(e.key)
  ) {
    return
  }


  if (isMorocco) {
    if (!/^[A-kkk0-9]$/.test(e.key)) {
      e.preventDefault()
    }
    return
  }

  // autres pays → chiffres seulement
  if (!/^[0-9]$/.test(e.key)) {
    e.preventDefault()
  }
}
  

  useEffect(() => {
    const hasValue =
   formik.values.identifiantCardNumber.trim() !== '' ||
      formik.values.confirmerNumeroCompte.trim() !== '' ||
      formik.values.accountNumber.trim() !== ''

    setIsObligatoire(hasValue)
  }, [formik.values.accountNumber, formik.values.identifiantCardNumber, formik.values.confirmerNumeroCompte])


const handleInputChangeConfirme = (event: React.ChangeEvent<HTMLInputElement>) => {
  const newValue = event.target.value

  formik.setFieldValue("confirmerNumeroCompte", newValue)

  if (/^\d+$/.test(newValue)) {
    const isValidInput = newValue === formik.values.accountNumber
    setIsConfirmIban(isValidInput)
  } 

}

  const handleChange = (iban: React.ChangeEvent<HTMLInputElement>) => {
     const value = iban.target.value.replace(/\s/g, '')
    formik.setFieldValue('prefix', selectedValue)

    if(selectedValue==='+90' || selectedValue ==='+63') 
      return formik.setFieldValue('accountNumber', value)
   
    const ibanPrefix = selectedValue === '+216' ? value.substring(0, 2) : value.substring(0, 3)
    const matchingBank = listCarteBancaire?.find((bank) => bank.code === ibanPrefix)

    if (matchingBank) {
      setIsConfirmListBanc(true)
      setBankcode(matchingBank.code)
      setSwiftBic(matchingBank.swift)
      setBanqueName(matchingBank.name)
      // setIban()
      // setTransferData({
      //   ...TransferData,
      //   banqueName: matchingBank.name,
      //   numBankBeneficiary: value,
      //   bankcode: matchingBank.code,
      //   swiftBic: matchingBank.swift,
      // })
    } else {
      setIsConfirmListBanc(false)

      setTransferData({ ...TransferData, banqueName: '' })
    }
  formik.setFieldValue('accountNumber', value)

    // formik.handleChange(iban)
  }


  useEffect(() => {
  const confirm = formik.values.accountNumber === formik.values.confirmerNumeroCompte && formik.values.accountNumber !== ''
  setIsConfirmIban(confirm)
}, [formik.values.accountNumber, formik.values.confirmerNumeroCompte])

  useEffect(() => {
    const hasErrors = Object.keys(formik.errors).length > 0

    const allConfirmed = isConfirmIban && isConfirmListBanc

    if (!hasErrors) {
      if (isObligatoire) {
        setDisabled(!allConfirmed)
      } else {
        setDisabled(false)
      }
    } else {
      setDisabled(true)
    }
  }, [formik.errors, isConfirmIban, isConfirmListBanc, isObligatoire])

console.log('optionstttt', options,  selectedValue)

  return (
    <div className="flex flex-col items-center justify-center  object-center ">
      {responseAddBeneficiary ? (
        <div className="relative my-2 mr-5 p-2 shadow max-w-max">
          <div className="absolute left-0 w-1 h-[25px] bg-[#e63131] ml-1"></div>
          <div className="relative z-10 pl-2 font-bold text-[18px] text-[#1D3A70]">
            Échec de l&apos;ajout du bénéficiaire
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="relative ">
        {newImage ? (
          <img
            src={newImage}
            className="w-[132px] h-[130px] rounded-full border-[#F9FAFB] border-8 sm:w-[80px] sm:h-[80px] object-cover"
          />
        ) : (
          <img
            src={imageDefault}
            className="w-[132px] h-[130px] rounded-full border-[#F9FAFB] border-8 sm:w-[80px] sm:h-[80px] object-cover"
            alt="Selected Image"
          />
        )}

        <img
          src={updateImage}
          className="w-8 h-8 cursor-pointer absolute right-0 bottom-0"
          onClick={() => setChoisirImage(true)}
        />

        <ModalImageBeneficiary
          isOpen={choisirImage}
          newImage={newImage}
          setNewImage={setNewImage}
          closeModal={closeModalImage}
          selectedImageId={selectedImageId}
          handleImageClick={handleImageClick}
        />
      </div>

      <form
        onSubmit={formik.handleSubmit}
        className={`flex flex-col items-center lg:justify-center  w-full  lg:gap-y-0 sm:px-5 gap-x-10  lg:w-full mt-3 lg:mt-0 px-2  ${OpenOptionnel && 'overflow-y-auto sm:pt-20  scrollbar-webkit h-[500px] '}`}
      >
        <div className="flex sm:flex-col w-full justify-between items-center gap-[24px] sm:gap-0">
          <div className="h-[120px] sm:h-[60px] w-full ">
            <div className="flex items-center sm:hidden ">
              <span className="text-[#6B7280] font-bold text-[16px] sm:mt-1">
                Prénom
                <span className="text-red-500 ">*</span>
              </span>
            </div>
            <input
              className="bg-[#F9FAFB] placeholder:text-[#D1D1FF] rounded-xl border border-transparent focus:border-[#5754E5] h-[50px] sm:h-[40px] text-[#1D3A70]  text-[16px] pl-[10px]  w-full sm:mt-1 mt-[12px] outline-none"
              type="text"
              value={formik.values.prenom}
              placeholder="Prénom"
              name="prenom"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur('prenom')}
              autoComplete="no"
              disabled={selectedOptionLien=== 'Moi même' ? true : false }
              // isDisabled
            />
            {formik.errors.prenom && formik.touched.prenom  ?(
              <div className="text-red-500 text-[9px] ">{formik.errors.prenom}</div>
            ): !isDisabled ? '' : ''}
          </div>

          <div className="h-[120px] sm:h-[60px] w-full">
            <div className="flex items-center sm:hidden ">
              <span className="text-[#6B7280] font-bold text-[16px] ">
                Nom <span className="text-red-500">*</span>
              </span>
            </div>
            <input
              className="bg-[#F9FAFB] placeholder:text-[#D1D1FF] rounded-xl border border-transparent focus:border-[#5754E5] h-[50px] sm:h-[40px] text-[#1D3A70] text-[16px] pl-[10px]  w-full sm:mt-1 mt-[12px] outline-none"
              type="text"
              name="nom"
              placeholder="Nom"
              value={formik.values.nom}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur('nom')}
              autoComplete="no"
              disabled={isDisabled}
            />
            {formik.errors.nom && formik.touched.nom && (
              <div className="text-red-500 text-[9px] ">{formik.errors.nom}</div>
            )}
          </div>
        </div>

        <div className="flex sm:flex-col w-full justify-between items-center sm:gap-0 gap-[24px]">
          <div className="h-[120px] sm:h-[60px] w-full ">
            <div className="flex flex-col w-full">
              <span className=" font-bold text-[16px] md:mt-1 sm:hidden text-[#6B7280] ">
                Genre <span className="text-red-500">*</span>
              </span>
              <label className=" relative inline-block mt-3 sm:mt-0 ">
                <input
                  type="text"
                  className="p-2 w-full placeholder:text-[#D1D1FF]  h-[50px] sm:h-[40px]  bg-[#F9FAFB] hover:cursor-pointer  border  border-transparent focus:border-[#5754E5] outline-none pl-[10px]  text-[16px] text-[#1D3A70] rounded-xl "
                  placeholder="Choisir un genre"
                  onClick={() => {
                    setIsOpenGenre(!isOpenGenre), setIsOpenLien(false)
                  }}
                  value={optionGenre.find((option) => option.code === selectedOptionGenre)?.name || ''}
                  onChange={(e) => {
                    formik.setFieldValue('selectedOptionGenre', e.target.value)
                    handleSelect(e.target.value)
                  }}
                  autoComplete="no"
                  onBlur={formik.handleBlur('selectedOptionGenre')}
                  name="selectedOptionGenre"
                  disabled={isDisabled}
                  readOnly
                />

                <img
                  src={iconSelectInput}
                  width={10}
                  height={10}
                  className=" absolute  right-3 top-1/2 hover:cursor-pointer"
                />

                <div
                  className={`absolute top-full left-0 z-10 min-h-auto max-h-[150px] rounded-lg w-full shadow-selct text-[#1D3A70] bg-white overflow-y-auto ${
                    isOpenGenre && !isDisabled ? 'block' : 'hidden'
                  }`}
                >
                  {optionGenre.map((optionGenre) => (
                    <div
                      key={optionGenre.code}
                      className="p-2 cursor-pointer hover:bg-gray-100 flex gap-3"
                      onClick={() => {
                        formik.setFieldValue('selectedOptionGenre', optionGenre.code),
                          handleSelectGenre(optionGenre.code)
                      }}
                    >
                      <img className="h-5" width={13} height={26} src={optionGenre.image} alt="genre de user" />
                      <div className="text-[15px] font-semibold">{optionGenre.name}</div>
                    </div>
                  ))}
                </div>
              </label>
            </div>
            <div>
              {formik.errors.selectedOptionGenre && formik.touched.selectedOptionGenre && (
                <div className="text-red-500 text-[9px] ">{formik.errors.selectedOptionGenre}</div>
              )}
            </div>
          </div>

          <div className="h-[120px] sm:h-[60px]  w-full">
            <div className="flex flex-col">
              <span className=" text-[#6B7280] font-bold text-[16px]  sm:hidden ">
                Lien <span className="text-red-500 ">*</span>
              </span>
              <label className="relative inline-block mt-3 sm:mt-0">
                <input
                  type="text"
                  className="p-2 w-full placeholder:text-[#D1D1FF] h-[50px] sm:h-[40px] bg-[#F9FAFB] hover:cursor-pointer  border  border-transparent focus:border-[#5754E5] outline-none pl-[10px]  text-[16px] text-[#1D3A70] rounded-xl "
                  placeholder="Choisir un lien"
                  onClick={() => {
                    setIsOpenLien(!isOpenLien), setIsOpenGenre(false)
                  }}
                  value={selectedOptionLien}
                  onChange={(e) => {
                    formik.setFieldValue('selectedOptionLien', e.target.value)
                    handleSelect(e.target.value)
                  }}
                  name="selectedOptionLien"
                  onBlur={formik.handleBlur('selectedOptionLien')}
                  autoComplete="no"
                  readOnly
                />
                <img src={iconSelectInput} className=" absolute right-3 top-1/2 hover:cursor-pointer" />

                <div
                  className={`absolute top-full left-0 z-10 min-h-auto max-h-[150px] w-full shadow-selct rounded-lg text-[#1D3A70] bg-white overflow-y-auto ${
                    isOpenLien ? 'block' : 'hidden'
                  }`}
                >
                  {optionsLien.map((LienList) => (
                    <div
                      key={LienList.code}
                      className="p-2 cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        formik.setFieldValue('selectedOptionLien', LienList.code)
                        handleSelectLien(LienList.name)
                        handleSelect(LienList)
                      }}
                    >
                      <div className="text-[#1D3A70] text-[15px] font-semibold">{LienList.name}</div>
                    </div>
                  ))}
                </div>
              </label>
            </div>

            {formik.errors.selectedOptionLien && formik.touched.selectedOptionLien && (
              <div className="text-red-500 text-[9px]">{formik.errors.selectedOptionLien}</div>
            )}
          </div>
        </div>

        {/* <div className='flex  w-full justify-between items-center sm:gap-3 gap-[24px]'> */}
        <div className="flex w-full justify-between items-center sm:gap-0 gap-[24px]">
          <div className="h-[120px] sm:h-[60px] w-full">
            <span className="text-[#6B7280] font-bold text-[16px] sm:hidden">
              Préfixe <span className="text-red-500">*</span>
            </span>
            <div className="mt-3 sm:mt-0    sm:h-[40px] hover:cursor-default">
              <CustomSelect
                options={options}
                value={options.find((item) => item.value === selectedValue)?.value || 'Préfixe'}
                onChange={(option) => {
                  setSelectedValue(option)
                  formik.setFieldValue('prefix', option)
  
                }}
                heightListe=" block  top-0"
                icon={options.find((item) => item.value === selectedValue)?.icon}
                
                height="h-[50px] sm:h-[40px] w-[260px] sm:w-[100px] relative"
                background="bg-[#F9FAFB] rounded-xl pl-[10px] pr-3 sm:pl-0 "
                textSize="text-[15px]   "
                heightDropdown="max-h-[120px] scrollbar-webkit w-[260px] sm:w-[100px]  absolute top-[56px] z-20"
                textColor="text-[#1D3A70]"
                iconSelect={iconSelectInput}
                // marginRightIcon="relative"
                roundedIcon="rounded-none"
                showArrow={isOpenListPays===false ? isOpenListPays : true}
              />
            </div>
          </div>

          <div className=" h-[120px] sm:h-[60px] w-full">
            <span className="text-[#6B7280] font-bold text-[16px] sm:hidden ">
              Numéro de téléphone <span className="text-red-500">*</span>
            </span>
            <input
              className="bg-[#F9FAFB] placeholder:text-[#D1D1FF]  text-[15px] h-[56px] border border-transparent focus:border-[#5754E5] outline-none  sm:w-[200px] rounded-xl  sm:h-[40px] pl-[10px] text-[#1D3A70] w-full sm:mt-0 mt-[12px]"
              type="text"
              value={formik.values.telephone}
              placeholder={formik.values.telephone ? formik.values.telephone : 'Numéro de téléphone'}
              name="telephone"
              onPaste={handlePaste}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur('telephone')}
              autoComplete="off"
              onKeyDown={handleKeyDown}
            />

            {formik.touched.telephone && formik.errors.telephone && (
              <div className="text-red-500 text-[9px]">{formik.errors.telephone}</div>
            )}
          </div>
        </div>
        {selectedValue !== '+880' && ( 
          <div className="w-full">
            <div
              className="flex w-full  text-[#1D3A70]  sm:h-[40px] gap-5 items-center font-bold cursor-pointer"
              onClick={() => setOpenOptionnel(!OpenOptionnel)}
            >
              Informations optionnelles{' '}
              <img
                src={iconSelectInput}
                className={`hover:cursor-pointer ${OpenOptionnel && ' rotate-180'}`}
                width={10}
                height={10}
              />
            </div>

            <div className={` w-full flex flex-col justify-center items-center  mt-3 sm:mt-0  }`}>
              {OpenOptionnel && (
                <div className="flex flex-col w-full ">
                  {selectedValue!=='+216' && 
                    <form className="  w-[280px] sm:w-full flex flex-col h-[120px] sm:h-[60px]">
                    <label className="h3 sm:hidden ">CIN du bénéficiaire</label>
                    <div className="relative mt-2">
                      <input
                        className=" border-[#AEB6FB] text-[#35258B] relative h-[50px] sm:h-[40px] rounded-[16px] placeholder:text-[#D1D1FF]  sm:w-full border  focus:border-[#5754E5] outline-none    text-[15px]  pl-[10px] w-full sm:mt-1"
                        type="text"
                        value={formik.values.identifiantCardNumber}
                        placeholder={`CIN du bénéficiaire `}
                        name="identifiantCardNumber"
                        onKeyDown={handleKeyDown}
                        maxLength={lengthCIN}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur('identifiantCardNumber')}
                        autoComplete='off'
                      />
                     
                    </div>
                    {/* text-[#B4B4B4] text-sm absolute right-2 */}
                    {formik.errors.identifiantCardNumber && formik.touched.identifiantCardNumber && (
                      <div className="text-red-500 text-[9px]">
                        {formik.errors.identifiantCardNumber}
                      </div>
                    )}
                  </form>
              }

                 {(selectedValue==='+90' || selectedValue ==='+63') &&
                 <div className='mb-4 sm:mt-2 w-full '>
                  <InputSelectComponent
                      liste={liste}
                      isOpen={isBankListOpen}
                      setIsOpen={setIsBankListOpen}
                      value={banqueName}
                      setValue={setBanqueName}
                      placeholder='Sélectionnez votre banque'
                      label='Sélectionnez votre banque'
                      handleClick={handleSelectedBank}
                      messageIsEmpty='Aucunne banque ajouté pour le moment'
                      styleInput='h-[50px] sm:h-[40px]'
                      styleLabel='h3 sm:hidden'
                   />
                  </div>
                  }

                  {/* <div className="flex sm:flex-col w-full justify-between items-center"> */}
                    <label className="text-[#6B7280]  text-[16px] h-[120px] sm:h-[60px] w-full ">
                      <div className="h3 sm:hidden "> {(selectedValue ==='+90' || selectedValue ==='+63') ? 'Numéro IBAN' : 'RIB'} </div>
                        {selectedValue ==='+216' &&<span className='text-[#422EAE] text-[14px] sm:text-[12px]'>(Seuls les comptes en dinars tunisiens (TND) sont acceptés)</span>}
                      <div className="h-[50px] sm:h-[40px]   border  border-[#AEB6FB] text-[#35258B] hover:border-[#5754E5] relative rounded-[16px]  w-full flex items-center mt-3">
                        <span className=" font-bold pl-[10px] text-[#1D3A70] flex items-center px-2">
                          {codeIBAN}
                        </span>
                        <input
                          type="text"
                          value={formik.values.accountNumber}
                          name="accountNumber"
                          onChange={handleChange}
                          onBlur={formik.handleBlur('accountNumber')}
                        
                          // onChange={handleChangeIBAN}
                          // onKeyDown={handleKeyDown}
                          placeholder={(selectedValue ==='+90' || selectedValue ==='+63') ? 'Numéro IBAN' : 'Numéro de compte bancaire'}
                          className="  placeholder:text-[#D1D1FF] outline-none  border border-transparent text-[#1D3A70]  w-full "
                          maxLength={
                            typeof lengthRIB === 'object'
                              ? lengthRIB.max
                              : lengthRIB
                          }
                          autoComplete='off'
                        />
                     
                      </div>
                      {formik.errors.accountNumber && (
                        <div className="text-red-500 text-[9px] ">{formik.errors.accountNumber}</div>
                      )}
                    </label>

                    <label className="  h-[120px]  sm:h-[60px] w-full text-[16px]  ">
                      <div className="h3 sm:hidden ">{(selectedValue ==='+90' || selectedValue ==='+63') ?  'Confirmez le numéro IBAN' :'Confirmez le numéro de compte'}</div>

                      <div className="h-[50px] sm:h-[40px]  border  border-[#AEB6FB] text-[#35258B] hover:border-[#5754E5] relative rounded-[16px]  pl-[10px] w-full flex items-center mt-3">
                        <span className="font-bold text-[#1D3A70] flex items-center  pr-2">
                          {codeIBAN}
                        </span>

                        <input
            
                          className="  placeholder:text-[#D1D1FF] outline-none  border border-transparent text-[#1D3A70]  w-full "
                          type="text"
                          value={formik.values.confirmerNumeroCompte}
                          placeholder={(selectedValue ==='+90' || selectedValue ==='+63') ?  'Confirmez le numéro IBAN' :'Confirmez le numéro de compte'}
                          name="confirmerNumeroCompte"
                          onChange={handleInputChangeConfirme}
                          onBlur={formik.handleBlur('confirmerNumeroCompte')}
                          maxLength={
                            typeof lengthRIB === 'object'
                              ? lengthRIB.max
                              : lengthRIB
                          }
                          autoComplete='off'
                        />
                        
                      </div>
                      {formik.errors.confirmerNumeroCompte && formik.touched.confirmerNumeroCompte && (
                        <div className="text-red-500 text-[9px]">
                          {formik.errors.confirmerNumeroCompte}
                        </div>
                      )}
                    </label>
                  </div>
                // </div>
              )}
            </div>
          </div>
          )} 

        <button
        
          type="submit"
          value="Submit"
          disabled={(Object.keys(formik.errors).length > 0 || ((selectedValue === '+90' || selectedValue ==='+63') &&   formik.values.accountNumber !== '' && !isSelectedBank))}
          className={` ${OpenOptionnel && 'z-10  bottom-2 '} my-3 px-[28px] py-2 h-[50px] sm:py-2 sm:h-[46px] rounded-xl text-[#FFF] text-[18px] font-semibold mx-auto  w-[350px] sm:w-[300px] 
            ${(Object.keys(formik.errors).length > 0 || ((selectedValue === '+90' || selectedValue ==='+63') &&   formik.values.accountNumber !== '' && !isSelectedBank))
    ? 'bg-[#D1D1FF] cursor-not-allowed' : 'bg-[#5754E5]'}
          `}
        >{ isLoading ? <svg
                  className="w-6 h-6 mx-auto animate-spin text-white "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-50"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                  ></path>
                </svg> :

              'Ajouter'
              }
        </button>
      </form>
    </div>
  )
}

export default ModalAddBeneficiary
